import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DashboardViewAsInterceptor } from '@app/main/merchant-dashboard/dashboard-view-as.service';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';
import { TransactionLimitMonitorServiceProxy } from './transaction-limit-monitor-service-proxy';

@NgModule({
    providers: [
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.ChannelServiceProxy,
        ApiServiceProxies.MerchantChannelServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.MerchantDashboardServiceProxy,
        ApiServiceProxies.DashboardAdminServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.PayPalPaymentServiceProxy,
        ApiServiceProxies.StripePaymentServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        ApiServiceProxies.WebhookEventServiceProxy,
        ApiServiceProxies.WebhookSubscriptionServiceProxy,
        ApiServiceProxies.WebhookSendAttemptServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        ApiServiceProxies.DynamicParameterServiceProxy,
        ApiServiceProxies.DynamicEntityParameterDefinitionServiceProxy,
        ApiServiceProxies.EntityDynamicParameterServiceProxy,
        ApiServiceProxies.DynamicParameterValueServiceProxy,
        ApiServiceProxies.EntityDynamicParameterValueServiceProxy,
        ApiServiceProxies.JobServiceProxy,
        ApiServiceProxies.PaymentGatewayServiceProxy,
        ApiServiceProxies.AdminPaymentGatewayServiceProxy,
        ApiServiceProxies.DisputeServiceProxy,
        ApiServiceProxies.PaymentGatewaySettingServiceProxy,
        ApiServiceProxies.PaymentGatewayJobServiceProxy,
        ApiServiceProxies.RegionServiceProxy,
        ApiServiceProxies.BankServiceProxy,
        ApiServiceProxies.TenantDetailsServiceProxy,
        ApiServiceProxies.PaymentFormSetupServiceProxy,
        ApiServiceProxies.PaymentFormServiceProxy,
        ApiServiceProxies.TenantWalletServiceProxy,
        ApiServiceProxies.TenantWalletTopupServiceProxy,
        ApiServiceProxies.DynamicTransientDataServiceProxy,
        ApiServiceProxies.TenantVirtualAccountServiceProxy,
        ApiServiceProxies.TransactionLimitSettingServiceProxy,
        ApiServiceProxies.ProviderReportServiceProxy,
        ApiServiceProxies.MerchantBankAccountServiceProxy,
        TransactionLimitMonitorServiceProxy,
        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
        // TEST ONLY: dashboard "view as tenant" header (ignored by the API unless enabled there)
        { provide: HTTP_INTERCEPTORS, useClass: DashboardViewAsInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
